import { languageGlobal } from "./GlobalVariableConfig";

export const getManifest = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    // {
                    //     alias: 'volatilityBase',
                    //     src: 'assets/desktop/2_intro/volatility_base.webp',
                    // },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/desktop/2_intro/volatility_on.webp',
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/desktop/2_intro/volatility_off.webp',
                    },
                    {
                        alias: 'intro_bg',
                        src: 'assets/desktop/2_intro/introduction_bg.webp',
                    },
                    // {
                    //     alias: 'introLogoStatic',
                    //     src: 'assets/desktop/1_loading/logo.webp',
                    // },
                    {
                        alias: 'introLogoSkel',
                        src: 'assets/desktop/2_intro/logo.skel',
                    },
                    {
                        alias: 'introLogoAtlas',
                        src: 'assets/desktop/2_intro/logo.atlas',
                    },
                    {
                        alias: 'introTicketSkel',
                        src: 'assets/desktop/2_intro/ticket.skel',
                    },
                    {
                        alias: 'introTicketAtlas',
                        src: 'assets/desktop/2_intro/ticket.atlas',
                    },
                    // text_base_smoke
                    // {
                    //     alias: 'textBaseSmoke',
                    //     src: 'assets/desktop/intro/text_base_smoke.webp',
                    // },
                    {
                        alias: 'image1',
                        src: 'assets/desktop/2_intro/image_1.png',
                    },
                    {
                        alias: 'image2',
                        src: 'assets/desktop/2_intro/image_2.png',
                    },
                    {
                        alias: 'image3',
                        src: 'assets/desktop/2_intro/image_3.png',
                    },
                    // {
                    //     alias: 'continueBase1',
                    //     src: 'assets/desktop/2_intro/continue_base.webp',
                    // },
                    // {
                    //     alias: 'introAppearSound',
                    //     src: 'assets/desktop/13_sounds/gameloading/Intro_appear.mp3',
                    // },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/9_bigwin/es/wins.skel' : 'assets/desktop/9_bigwin/wins.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/9_bigwin/es/wins.atlas' : 'assets/desktop/9_bigwin/wins.atlas',
                    },
                    // {
                    //     alias: 'amount_base',
                    //     src: 'assets/desktop/bigwin/win_amount_base.webp',
                    // },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    {
                        alias: 'background',
                        src: 'assets/desktop/6_basegame/basegame.webp',
                    },
                    {
                        alias: 'backgroundFree',
                        src: 'assets/desktop/6_basegame/freegame.webp',
                    },
                    // {
                    //     alias: 'reelBackFree',
                    //     src: 'assets/desktop/11_reelframe/reelBackFree.webp',
                    // },
                    {
                        alias: 'reelBackBase',
                        src: 'assets/desktop/11_reelframe/reelBackBase.webp',
                    },
                    // {
                    //     alias: 'reelFrameFgSkel',
                    //     src: 'assets/desktop/11_reelframe/freegame_reel/freegame_reel.skel',
                    // },
                    // {
                    //     alias: 'reelFrameFgAtlas',
                    //     src: 'assets/desktop/11_reelframe/freegame_reel/freegame_reel.atlas',
                    // },
                    // {
                    //     alias: 'logoBaseBasegame',
                    //     src: 'assets/desktop/base/reel/basegame_logo_base.webp',
                    // },
                    // {
                    //     alias: 'logoBaseFreegame',
                    //     src: 'assets/desktop/base/reel/freegame_logo_base.webp',
                    // },
                    // {
                    //     alias: 'opa_winPatch',
                    //     src: 'assets/desktop/11_reelframe/opa_winPatch.png',
                    // },
                    // character animation *********************
                    {
                        alias: 'characterSkel',
                        src: 'assets/desktop/5_character/character.skel',
                    },
                    {
                        alias: 'characterAtlas',
                        src: 'assets/desktop/5_character/character.atlas',
                    },
                    // hand gun shoot animation *********************
                    {
                        alias: 'gunShootSkel',
                        src: 'assets/desktop/6_basegame/gun_ shooting/gun_ shooting.skel',
                    },
                    {
                        alias: 'gunShootAtlas',
                        src: 'assets/desktop/6_basegame/gun_ shooting/gun_ shooting.atlas',
                    },
                    // Game Intro animation *********************
                    {
                        alias: 'gameIntroSkel',
                        src: 'assets/desktop/3_gameintro/game_intro.skel',
                    },
                    {
                        alias: 'gameIntroAtlas',
                        src: 'assets/desktop/3_gameintro/game_intro.atlas',
                    },
                    //logo *********************
                    // {
                    //     alias: 'logoStatic',
                    //     src: 'assets/desktop/4_logo/logoStatic.webp',
                    // },
                    //highlight *********************
                    // {
                    //     alias: 'highlightFrame',
                    //     src: 'assets/desktop/base/highlite_frame.webp',
                    // },
                    // //logo animation *********************
                    {
                        alias: 'frameSkel',
                        src: 'assets/desktop/8_freegame/spot_frame/blue_frame.skel',
                    },
                    {
                        alias: 'frameAtlas',
                        src: 'assets/desktop/8_freegame/spot_frame/blue_frame.atlas',
                    },
                    //multi fx bid ***
                    {
                        alias: 'multiFxBigSkel',
                        src: 'assets/desktop/6_basegame/multi_fx_big/multi_fx_big.skel',
                    },
                    {
                        alias: 'multiFxBigAtlas',
                        src: 'assets/desktop/6_basegame/multi_fx_big/multi_fx_big.atlas',
                    },
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/desktop/4_logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/desktop/4_logo/logo.atlas',
                    },
                    // transition
                    // {
                    //     alias: 'transitionSkel',
                    //     src: 'assets/desktop/base/transition/transition.skel',
                    // },
                    // {
                    //     alias: 'transitionAtlas',
                    //     src: 'assets/desktop/base/transition/transition.atlas',
                    // },
                    // multiplier meter fx *********************
                    // {
                    //     alias: 'multiplerMeterFxSkel',
                    //     src: 'assets/desktop/base/multiplier_meter_fx/multiplier.skel',
                    // },
                    // {
                    //     alias: 'multiplerMeterFxAtlas',
                    //     src: 'assets/desktop/base/multiplier_meter_fx/multiplier.atlas',
                    // },

                    // exp wild fx *********************
                    {
                        alias: 'expWildFxSkel',
                        src: 'assets/desktop/6_basegame/expanding_wild_fx/expanding_fx.skel',
                    },
                    {
                        alias: 'expWildFxAtlas',
                        src: 'assets/desktop/6_basegame/expanding_wild_fx/expanding_fx.atlas',
                    },
                    {
                        alias: 'winLineSkel',
                        src: 'assets/desktop/14_paylines/payline.skel',
                    },
                    {
                        alias: 'winLineAtlas',
                        src: 'assets/desktop/14_paylines/payline.atlas',
                    },
                    {
                        alias: 'reelGunSkel',
                        src: 'assets/desktop/15_reelCellFix/reel_gun_shot/reel_gun_shot.skel',
                    },
                    {
                        alias: 'reelGunAtlas',
                        src: 'assets/desktop/15_reelCellFix/reel_gun_shot/reel_gun_shot.atlas',
                    },
                    {
                        alias: 'reelMultiFxSkel',
                        src: 'assets/desktop/15_reelCellFix/reel_multi_fx/reel_multi_fx.skel',
                    },
                    {
                        alias: 'reelMultiFxAtlas',
                        src: 'assets/desktop/15_reelCellFix/reel_multi_fx/reel_multi_fx.atlas',
                    },
                    {
                        alias: 'reelMultiMergeSkel',
                        src: 'assets/desktop/15_reelCellFix/reel_multi_marge_fx/reel_multi_marge_fx.skel',
                    },
                    {
                        alias: 'reelMultiMergeAtlas',
                        src: 'assets/desktop/15_reelCellFix/reel_multi_marge_fx/reel_multi_marge_fx.atlas',
                    },
                    {
                        alias: 'winAmountFxSkel',
                        src: 'assets/desktop/15_reelCellFix/amount_fx/amounte_fx.skel',
                    },
                    {
                        alias: 'winAmountFxAtlas',
                        src: 'assets/desktop/15_reelCellFix/amount_fx/amounte_fx.atlas',
                    },
                    //banner *********************
                    // {
                    //     alias: 'banner',
                    //     src: 'assets/desktop/banner/intro_outro_base.webp',
                    // },
                    //banner-spine
                    {
                        alias: 'freegame_intro_bg',
                        src: 'assets/desktop/7_banner/bg.webp',
                    },
                    //banner-left-char
                    {
                        alias: 'bannerBaseSkel',
                        src: 'assets/desktop/7_banner/intro_outro.skel',
                    },
                    {
                        alias: 'bannerBaseAtlas',
                        src: 'assets/desktop/7_banner/intro_outro.atlas',
                    },
                    //base game background animation
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/desktop/6_basegame/background/basegame_bg.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/desktop/6_basegame/background/basegame_bg.atlas',
                    },
                    //free game background animation
                    {
                        alias: 'freeBackgroundSkel',
                        src: 'assets/desktop/8_freegame/background/freegame_bg.skel',
                    },
                    {
                        alias: 'freeBackgroundAtlas',
                        src: 'assets/desktop/8_freegame/background/freegame_bg.atlas',
                    },
                    // multiplier effect
                    // {
                    //     alias: 'multiplierBlastSkel',
                    //     src: 'assets/desktop/base/multiplier_blast/multiplier_blast.skel',
                    // },
                    // {
                    //     alias: 'multiplierBlastAtlas',
                    //     src: 'assets/desktop/base/multiplier_blast/multiplier_blast.atlas',
                    // },
                    //amount effect
                    {
                        alias: 'amountEffectSkel',
                        src: 'assets/desktop/6_basegame/amount_effect/amount_effect.skel',
                    },
                    {
                        alias: 'amountEffectAtlas',
                        src: 'assets/desktop/6_basegame/amount_effect/amount_effect.atlas',
                    },
                    //symbols *********************
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/desktop/12_symbols/hv1/hv_1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/desktop/12_symbols/hv1/hv_1.atlas',
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/desktop/12_symbols/hv2/hv_2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/desktop/12_symbols/hv2/hv_2.atlas',
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/desktop/12_symbols/hv3/hv_3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/desktop/12_symbols/hv3/hv_3.atlas',
                    },
                    //hv4
                    {
                        alias: 'hv4Skel',
                        src: 'assets/desktop/12_symbols/hv4/hv_4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/desktop/12_symbols/hv4/hv_4.atlas',
                    },
                    //hv5
                    {
                        alias: 'hv5Skel',
                        src: 'assets/desktop/12_symbols/hv5/hv5.skel',
                    },
                    {
                        alias: 'hv5Atlas',
                        src: 'assets/desktop/12_symbols/hv5/hv5.atlas',
                    },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/desktop/12_symbols/lv1/lv_1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/desktop/12_symbols/lv1/lv_1.atlas',
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/desktop/12_symbols/lv2/lv_2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/desktop/12_symbols/lv2/lv_2.atlas',
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/desktop/12_symbols/lv3/lv_3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/desktop/12_symbols/lv3/lv_3.atlas',
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.atlas',
                    },
                    //lv5
                    {
                        alias: 'lv5Skel',
                        src: 'assets/desktop/12_symbols/lv5/lv_5.skel',
                    },
                    {
                        alias: 'lv5Atlas',
                        src: 'assets/desktop/12_symbols/lv5/lv_5.atlas',
                    },
                    //lv6
                    // {
                    //     alias: 'lv6Skel',
                    //     src: 'assets/desktop/12_symbols/lv6/lv_6.skel',
                    // },
                    // {
                    //     alias: 'lv6Atlas',
                    //     src: 'assets/desktop/12_symbols/lv6/lv_6.atlas',
                    // },
                    //scatter
                    {
                        alias: 'scatterSkel',
                        src: 'assets/desktop/12_symbols/scatter/scatter.skel',
                    },
                    {
                        alias: 'scatterAtlas',
                        src: 'assets/desktop/12_symbols/scatter/scatter.atlas',
                    },
                    //wild
                    {
                        alias: 'wildSkel',
                        src: 'assets/desktop/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'wildAtlas',
                        src: 'assets/desktop/12_symbols/wild/wild.atlas',
                    },
                    //shutter
                    // {
                    //     alias: 'shutterSkel',
                    //     src: 'assets/desktop/12_symbols/shutter/shutter.skel',
                    // },
                    // {
                    //     alias: 'shutterAtlas',
                    //     src: 'assets/desktop/12_symbols/shutter/shutter.atlas',
                    // },
                    // //windmill
                    // {
                    //     alias: 'windmillSkel',
                    //     src: 'assets/desktop/12_symbols/windmill/windmill.skel',
                    // },
                    // {
                    //     alias: 'windmillAtlas',
                    //     src: 'assets/desktop/12_symbols/windmill/windmill.atlas',
                    // },
                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/desktop/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/desktop/12_symbols/wild/wild.atlas',
                    },
                    //win_digit_export
                    {
                        alias: 'win_digit_export',
                        src: 'assets/desktop/10_fonts/win_export/digit_export.xml',
                    },
                    {
                        alias: 'win_digit_export',
                        src: 'assets/desktop/10_fonts/ArchivoBlack-Regular.ttf',
                    },
                    {
                        alias: 'Bombardier',
                        src: 'assets/desktop/10_fonts/bombardier.regular.ttf',
                    },
                    //symbol_multiplier
                    {
                        alias: 'symbol_multiplier',
                        src: 'assets/desktop/10_fonts/multiplier.xml',
                    },
                    //PenguineRoyale_ttf
                    {
                        alias: 'junegull',
                        src: 'assets/desktop/10_fonts/junegull.otf',
                    },
                    {
                        alias: 'fetteegyptienne',
                        src: 'assets/desktop/10_fonts/FETTE.ttf',
                    },
                    {
                        alias: 'Germania',
                        src: 'assets/desktop/10_fonts/penguine_germania/GermaniaOne.ttf',
                    },
                    {
                        alias: 'Grandstander',
                        src: 'assets/desktop/10_fonts/Grandstander.ttf',
                    },
                    //multiplier- font
                    {
                        alias: 'penguine_multiplier',
                        src: 'assets/desktop/10_fonts/penguine_reel_multiplier/penguine_multiplier.xml',
                    },
                    {
                        alias: 'penguine_reel_multiplier',
                        src: 'assets/desktop/10_fonts/penguine_reel_multiplier/penguine_reel_multiplier.xml',
                    },
                    {
                        alias: 'penguine_banner_multiplier',
                        src: 'assets/desktop/10_fonts/penguine_reel_multiplier/banner_multiplier/banner_multiplier.xml',
                    },
                    // OPA! Fonts
                    {
                        alias: 'norse',
                        src: 'assets/desktop/10_fonts/Norsebold.otf',
                    },
                    {
                        alias: 'adonais',
                        src: 'assets/desktop/10_fonts/Adonais.ttf',
                    },
                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/desktop/13_sounds/ui/betlevel.mp3',
                    },
                    {
                        alias: 'reel_spinning',
                        src: 'assets/desktop/13_sounds/spin/reel_spinning.mp3',
                    },
                    {
                        alias: 'win_amount_disappears',
                        src: 'assets/desktop/13_sounds/base/win_amount_disappears.mp3',
                    },
                    {
                        alias: 'reveal_multiplier',
                        src: 'assets/desktop/13_sounds/base/reveal_multiplier.mp3',
                    },
                    {
                        alias: 'multipliers_move',
                        src: 'assets/desktop/13_sounds/base/multipliers_move.mp3',
                    },
                    {
                        alias: 'multiplier_boost',
                        src: 'assets/desktop/13_sounds/base/multiplier_boost.mp3',
                    },
                    {
                        alias: 'tally_counter',
                        src: 'assets/desktop/13_sounds/base/OR_tally_counter.mp3',
                    },
                    {
                        alias: 'tally_win_amount',
                        src: 'assets/desktop/13_sounds/base/OR_tally_win_amount.mp3',
                    },
                    {
                        alias: 'tally_total_disappears',
                        src: 'assets/desktop/13_sounds/base/OR_tally_total_disappears.mp3',
                    },
                    {
                        alias: 'tally_totaling',
                        src: 'assets/desktop/13_sounds/base/OR_tally_totaling.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/desktop/13_sounds/ui/btn_spin.mp3',
                    },
                    {
                        alias: 'OR_bonus_text_appears',
                        src: 'assets/desktop/13_sounds/freegame/OR_bonus_text_appears.mp3',
                    },
                    {
                        alias: 'OR_bonus_text_disappears',
                        src: 'assets/desktop/13_sounds/freegame/OR_bonus_text_disappears.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        // src: 'assets/desktop/13_sounds/flf_mx_basegame.mp3',
                        src: 'assets/desktop/13_sounds/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'free_music_ambient',
                        // src: 'assets/desktop/13_sounds/flf_mx_basegame.mp3',
                        src: 'assets/desktop/13_sounds/freegame/OR_FS_desert_ambience.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/desktop/13_sounds/base/Bg_loop.mp3',
                    },
                    {
                        alias: 'man_jump',
                        src: 'assets/desktop/13_sounds/gameloading/man_jump.mp3',
                    },
                    {
                        alias: 'scene_expansion',
                        src: 'assets/desktop/13_sounds/gameloading/scene_expansion.mp3',
                    },
                    {
                        alias: 'wall_crack',
                        src: 'assets/desktop/13_sounds/gameloading/wall_crack.mp3',
                    },
                    {
                        alias: 'Intro_transition',
                        src: 'assets/desktop/13_sounds/gameloading/Intro_transition.mp3',
                    },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/desktop/13_sounds/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'FS_TRANSITION',
                        src: 'assets/desktop/13_sounds/freegame/OR_transition_2_FS.mp3',
                    },
                    {
                        alias: 'BASE_TRANSITION',
                        src: 'assets/desktop/13_sounds/base/OR_bonus_transition_2_main game.mp3',
                    },
                    {
                        alias: 'OR_letter_ricochet',
                        src: 'assets/desktop/13_sounds/base/OR_letter_ricochet.mp3',
                    },
                    {
                        alias: 'wild_symbol',
                        src: 'assets/desktop/13_sounds/base/OR_wild_symbol.mp3',
                    },
                    {
                        alias: 'OR_gunslinger',
                        src: 'assets/desktop/13_sounds/feature/OR_gunslinger.mp3',
                    },
                    {
                        alias: 'OR_big_win_exit',
                        src: 'assets/desktop/13_sounds/bigwin/OR_big_win_exit.mp3',
                    },
                    {
                        alias: 'OR_big_win_intro',
                        src: 'assets/desktop/13_sounds/bigwin/OR_big_win_exit.mp3',
                    },
                    {
                        alias: 'free_Game_Banner',
                        src: 'assets/desktop/13_sounds/freegame/free_Game_Banner.mp3',
                    },
                    {
                        alias: 'total_win',
                        src: 'assets/desktop/13_sounds/freegame/total_win.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/desktop/13_sounds/freegame/Scatter_Trigger.mp3',
                    },
                    {
                        alias: 'fsSpin_awarded',
                        src: 'assets/desktop/13_sounds/freegame/additional_fspins.mp3',
                    },
                    {
                        alias: 'reel_stop',
                        src: 'assets/desktop/13_sounds/spin/reel_stop.mp3',
                    },
                    {
                        alias: 'scatter_stop',
                        src: 'assets/desktop/13_sounds/spin/scatter_landing.mp3',
                    },
                    {
                        alias: 'multiplier_collect',
                        src: 'assets/desktop/13_sounds/spin/multiplier_collect.mp3',
                    },
                    {
                        alias: 'reel_greenlight_anticipation',
                        src: 'assets/desktop/13_sounds/spin/reel_greenlight_anticipation.mp3',
                    },
                    {
                        alias: 'symbol_transform_to_wild',
                        src: 'assets/desktop/13_sounds/spin/symbol_transform_to_wild.mp3',
                    },
                    {
                        alias: 'wild_symbol_shooting_bluemagic',
                        src: 'assets/desktop/13_sounds/spin/wild_symbol_shooting_bluemagic.mp3',
                    },
                    {
                        alias: 'man_anim_sword_pointing_up',
                        src: 'assets/desktop/13_sounds/spin/man_anim_sword_pointing_up.mp3',
                    },
                    {
                        alias: 'man_anim_sword_to_hand',
                        src: 'assets/desktop/13_sounds/spin/man_anim_sword_to_hand.mp3',
                    },
                    {
                        alias: 'man_anim_when_bonus_trg',
                        src: 'assets/desktop/13_sounds/spin/man_anim_when_bonus_trg.mp3',
                    },
                    {
                        alias: 'symbol_win',
                        src: 'assets/desktop/13_sounds/win/common_win.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/desktop/13_sounds/win/higher_win.mp3',
                    },
                    {
                        alias: 'symbol_cascade',
                        src: 'assets/desktop/13_sounds/win/symbol_explosion.mp3',
                    },
                    {
                        alias: 'multiplier_amount',
                        src: 'assets/desktop/13_sounds/base/OR_multiplier_amount_01.mp3',
                    },
                    {
                        alias: 'multiplier_moves_to_tally',
                        src: 'assets/desktop/13_sounds/base/OR_multiplier_moves_to_tally.mp3',
                    },
                    // {
                    //     alias: 'higher_win',
                    //     src: 'assets/desktop/13_sounds/win/higher_win.mp3',
                    // },
                    {
                        alias: 'win_loop',
                        src: 'assets/desktop/13_sounds/bigwin/Win_Loop.mp3',
                    },

                    {
                        alias: 'Big_Win_Transition',
                        src: 'assets/desktop/13_sounds/bigwin/Big_Win_Transition.mp3',
                    },
                    {
                        alias: 'Mega_Win_Transition',
                        src: 'assets/desktop/13_sounds/bigwin/Mega_Win_Transition.mp3',
                    },
                    {
                        alias: 'Super_Win_Transition',
                        src: 'assets/desktop/13_sounds/bigwin/Super_Win_Transition.mp3',
                    },
                    {
                        alias: 'Epic_Win_Transition',
                        src: 'assets/desktop/13_sounds/bigwin/Epic_Win_Transition.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/desktop/13_sounds/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'OR_big_win_intro',
                        src: 'assets/desktop/13_sounds/bigwin/OR_big_win_intro.mp3',
                    },
                    {
                        alias: 'big_mega_win_full',
                        src: 'assets/desktop/13_sounds/bigwin/OR_big_mega_win_full.mp3',
                    },
                    {
                        alias: 'bonus_total_win',
                        src: 'assets/desktop/13_sounds/freegame/OR_bonus_total_win.mp3',
                    },
                    {
                        alias: 'scatter_land',
                        src: 'assets/desktop/13_sounds/base/OR_scatter_land.mp3',
                    },
                    {
                        alias: 'multiply_transition',
                        src: 'assets/desktop/13_sounds/base/OR_multiply_transition.mp3',
                    },
                    {
                        alias: 'row_drop',
                        src: 'assets/desktop/13_sounds/base/OR_row_drop.mp3',
                    },
                    {
                        alias: 'scatter_symbol',
                        src: 'assets/desktop/13_sounds/base/OR_scatter_symbol.mp3',
                    },
                    {
                        alias: 'scatter_symbol_explodes',
                        src: 'assets/desktop/13_sounds/base/OR_scatter_symbol_explodes.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/desktop/13_sounds/bigwin/Win_Count_up_End.mp3',
                    },
                    //Character sounds
                    {
                        alias: 'glass_sip', //Laughing
                        src: 'assets/desktop/13_sounds/character/animation1.mp3',
                    },
                    // {
                    //     alias: 'slam_the_ground', //action_2
                    //     src: 'assets/desktop/13_sounds/character/slam_the_ground.mp3',
                    // },
                    // {
                    //     alias: 'jump',  // jump
                    //     src: 'assets/desktop/13_sounds/character/jump.mp3',
                    // },
                    // {
                    //     alias: 'low_hand_raise',
                    //     src: 'assets/desktop/13_sounds/character/low_hand_raise.mp3', //idle_3
                    // },
                    // {
                    //     alias: 'full_sword_up',
                    //     src: 'assets/desktop/13_sounds/character/full_sword_up.mp3',
                    // },
                    // {
                    //     alias: 'back_scratching',
                    //     src: 'assets/desktop/13_sounds/character/back_scratching.mp3',
                    // },
                    //multiplier sounds
                    {
                        alias: 'multiplier_panel',
                        src: 'assets/desktop/13_sounds/win/multiplier_panel.mp3',
                    },
                    {
                        alias: 'multiplier_move',
                        src: 'assets/desktop/13_sounds/win/multiplier_move.mp3',
                    },
                    // Wild Appear
                    {
                        alias: 'wild_appear',
                        src: 'assets/desktop/13_sounds/win/wild_appear.mp3',
                    },
                    //Feature related
                    {
                        alias: 'multiplier_on_plates',
                        src: 'assets/desktop/13_sounds/feature/multiplier_landing_plates.mp3',
                    },
                    {
                        alias: 'multiplier_on_shutter',
                        src: 'assets/desktop/13_sounds/feature/multiplier_landing_window.mp3',
                    },
                    {
                        alias: 'windmill_trigger',
                        src: 'assets/desktop/13_sounds/feature/windmill_highlight.mp3',
                    },
                    {
                        alias: 'windmill_spread',
                        src: 'assets/desktop/13_sounds/feature/windmill_cascade.mp3',
                    },
                    {
                        alias: 'windmill_reveal_to_plateandshutter',
                        src: 'assets/desktop/13_sounds/feature/windmill_reveal.mp3',
                    },
                    {
                        alias: 'shutter_opening',
                        src: 'assets/desktop/13_sounds/feature/window_opening.mp3',
                    },
                    {
                        alias: 'windmill_appear',
                        src: 'assets/desktop/13_sounds/feature/windmill_show.mp3',
                    },
                ],
            },

        ],
    }
};

